module.exports = __webpack_public_path__ + "static/img/21.2905575.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/3/zh/21.png
// module id = OUcN
// module chunks = 0